import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  title: '',
  message: '',
  confirmText: '',
  cancelText: '',
  onConfirm: null,
  onCancel: null,
};

const confirmModalSlice = createSlice({
  name: 'confirmModal',
  initialState,
  reducers: {
    showConfirm: (state, action) => {
      const { title, message, confirmText, cancelText, onConfirm, onCancel } = action.payload;

      state.isOpen = true;
      state.title = title;
      state.message = message;
      state.confirmText = confirmText;
      state.cancelText = cancelText;
      state.onConfirm = onConfirm;
      state.onCancel = onCancel;
    },
    hideConfirm: () => initialState,
  },
});

export const { showConfirm, hideConfirm } = confirmModalSlice.actions;
export default confirmModalSlice.reducer;
